<svelte:options
	customElement={{
		tag: "media-player",
		shadow: "none",
	}}
/>

<script lang="ts">
	import { onMount, createEventDispatcher } from "svelte";
	import type { StreamPlayerApi } from "./cloudflare-stream";
	import IntersectionObserver from "svelte-intersection-observer";

	export let videoId: string;
	export let width: number;
	export let height: number;
	export let loop: boolean = true;

	let isMuted: boolean = true;
	let isStreamPlaying: boolean = true;
	let streamSurface: HTMLIFrameElement;
	let streamPlayer: StreamPlayerApi;
	
	$: aspectRatio = width / height;

	onMount(() => {
		initialize();
	});

	function initialize() {
		if (streamPlayer != null) {
			return;
		}

		if (window.Stream != null) {
			if (streamPlayer == null) {
				streamPlayer = window.Stream(streamSurface);
				streamPlayer.addEventListener("play", () => {
					streamSurface.style.opacity = 1;
				});
			}
		}
	}

	async function onIntersect(e) {
		if (streamPlayer != null) {
			await streamPlayer.play();
		}
	}
</script>

<style lang="scss">
	:global(media-player) {
		display: flex;
		align-items: center;
	}

	.player-wrapper {
		position: absolute;
		inset: 0;
		z-index: 0;
		overflow: hidden;
	}
	
	iframe {
		position: absolute;
		min-width: 100%;
		min-height: 100%;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		opacity: 0;
	}
</style>

<svelte:window on:cloudflareStreamReady={initialize} />

<IntersectionObserver element={streamSurface} on:intersect={onIntersect}>
	<div class="player-wrapper">
		<iframe bind:this={streamSurface} style:aspect-ratio={aspectRatio} src={`https://customer-dbvjtzrax9zx0mi1.cloudflarestream.com/${videoId}/iframe?controls=false&muted=true&autoplay=true&${loop ? "loop=true" : ""}&poster=https%3A%2F%2Fcustomer-dbvjtzrax9zx0mi1.cloudflarestream.com%2F${videoId}%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600`} loading="lazy" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" allowfullscreen="true"></iframe>
	</div>
</IntersectionObserver>
